import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import Notification from '../../../../components/Notification/Notification';
import history from '../../../../utils/history';
import { basicMissionListRequest } from '../../../../redux/actions/app/basicActions';
import { getUserPageAuth } from '../../../../utils/page-auth';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import { convertBigNumToDecimalString } from '../../../../utils/convert-decimal-to-big-num';
import useSchemaBasicMissionMain from '../../../../schema/table-schema/useSchemaBasicMissionMain';
import BOTable from '../../../../components/Tables/BOTable';
import Visible from '../../../../components/Custom/Visible';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';

function BasicMissionMain() {
  // -- component const --//
  const title = '베이직 미션';
  const OPTION_KEY = Page.APP_BASIC_MISSION;

  const { schema } = useSchemaBasicMissionMain();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(25);

  const [isLoading, setIsLoading] = useState(false);
  const [tBody, setTbody] = useState();
  const [totalCount, setTotalCount] = useState(0);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      basicMissionListRequest({
        page: page,
        pageLength: Number(pageLength),
        callback: (data) => {
          console.log('요청 결과: ', data);
          setTotalCount(data?.totalCount);
          // setTbody(data?.list);

          // 인덱스를 추가하여 새로운 배열을 생성(중복 키 방지)
          const listWithIndex = data?.list.map((item, index) => ({
            index: index + 1, // 인덱스는 1부터 시작(번호 표기시 편의를 위해)
            ...item,
          }));

          setTbody(listWithIndex);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      }),
    );
  }

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(value);
    setPage(1);
  };

  const handleClickRow = (row) => {
    if (row?.missionNo) {
      const missionNo = row?.missionNo;
      history.push('/admin/app/basic/mission/basicMissionInfo', {
        missionNo,
      });
    }
  };

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

  // -- render --//
  return (
    <div className='page'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <section className="topSection">
        <div className="leftSection">
          <p className="titleText">{title}</p>
        </div>

        <div className="rightSection">
            <button
                className={"outlineBtn"}
                onClick={() => {
                    fetchList();
                }}
            >
                List 갱신
            </button>
          <button
            className="defaultBtn"
            disabled={readOnly}
            onClick={() => history.push('/admin/app/basic/mission/basicMissionRegist', { readOnly: readOnly })}
          >
            새 미션 추가
          </button>
        </div>
      </section>

      <div className="spaceDiv10"/>

        <Visible Visible visible={pageOption?.bottom_paging}>
            <PaginationComponent
                disable={false}
                option={pageOption}
                page={page}
                pageLength={pageLength}
                totalCount={totalCount}
                onChange={handlePageChange}
                onSelect={handlePageLengthChange}
            />
        </Visible>

        <div className="spaceDiv10"/>


      <BOTable
        className={'basicMissionMainTable'}
        schema={schema}
        rows={tBody}
        loading={isLoading}
        onClick={handleClickRow}
      />

      <div className="spaceDiv10"/>



      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  )
}

export default BasicMissionMain;
